import request from '@/utils/request'

let Ad_bureauApi = {

  /*管理局列表*/
  list(data) {
    return request._post('/shop/plus.ad_bureau.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.ad_bureau.Index/indexx', data);
},
/*添加管理局*/
add(data) {
    return request._post('/shop/plus.ad_bureau.Index/add', data);
},
/*修改管理局*/
edit(data) {
    return request._post('/shop/plus.ad_bureau.Index/edit', data);
},
/*删除管理局*/
del(data) {
    return request._post('/shop/plus.ad_bureau.Index/del', data);
},
/*管理局详情*/
detail(data) {
  return request._post('/shop/plus.ad_bureau.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ad_bureau.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ad_bureau.Setting/getSetting', data, errorback);
    },
}
export default Ad_bureauApi;



// WEBPACK FOOTER //
// ./src/api/ad_bureau.js